var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-40"},[_c('div',{staticClass:"mt-6 pt-12 border-t-2 border-gray-300"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }